exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-68a42dfa].template-card{padding:25px;background-color:whitesmoke;margin:25px;border-radius:5px;-webkit-box-shadow:1px 2px 3px 2px rgba(148,121,148,0.7);-moz-box-shadow:1px 2px 3px 2px rgba(148,121,148,0.7);box-shadow:1px 2px 3px 2px rgba(148,121,148,0.7)}\n", ""]);

